import React, { useEffect} from "react";
import { Row, Form } from "react-bootstrap";

import { useGlobalState } from '../../components/globalStateProvider';
import { machineSNListSelectedGlassTimeCustomerAPI } from '../../api/api_definitions.js';


const GlassTimeCustomerListCustomer = () => {
  const { machineFamilyGlassTimeCustomer, customerNameGlassTimeCustomer, 
          setCustomerNameGlassTimeCustomer, listCustomerGlassTimeCustomer, 
          setListSNMachinesGlassTimeCustomer, setSnMachineGlassTimeCustomer 
        } = useGlobalState();

    // Reset the info
    useEffect(() => {
      setSnMachineGlassTimeCustomer("");
    }, [machineFamilyGlassTimeCustomer, customerNameGlassTimeCustomer]); 


   // API GATEWAY RESPONSE MANAGEMENT WITH MEMO (AVOID DOUBLE CALL) --> RETURN LIST OF CUSTOMERS
   const memoizedMachineSNListSelectedCustomerGlassTimeAPI = (() => {
    let cachedData = {}; // Cache for storing results
    return async (machineFamilyGlassTimeCustomer, customerNameGlassTimeCustomer) => {
      if (!cachedData[machineFamilyGlassTimeCustomer]) {
        cachedData[machineFamilyGlassTimeCustomer] = await machineSNListSelectedGlassTimeCustomerAPI(machineFamilyGlassTimeCustomer, customerNameGlassTimeCustomer);
      }
      return cachedData[machineFamilyGlassTimeCustomer];
    };
  })();

  useEffect(() => {
    let isMounted = true;
    memoizedMachineSNListSelectedCustomerGlassTimeAPI(machineFamilyGlassTimeCustomer, customerNameGlassTimeCustomer)
      .then((dataAPI) => {
        if (isMounted) {
          console.log("Data List SN", dataAPI);
          if (dataAPI !== null) {
            setListSNMachinesGlassTimeCustomer(dataAPI.ListSNMachines);
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
    return () => {
      isMounted = false;
    };
  }, [customerNameGlassTimeCustomer, setListSNMachinesGlassTimeCustomer]);

  // Return layout
  return (
    <Row className="text-center mt-4 mb-4">
      <Form.Select
        aria-label="Default select example"
        as="select"
        value={customerNameGlassTimeCustomer}
        onChange={e => {
          if (e.target.value !== "") {
            setCustomerNameGlassTimeCustomer(e.target.value);
          }
        }}>
        <option value="" disabled>Seleziona un cliente</option>
        {listCustomerGlassTimeCustomer.map((item, index) => (
          <option value={item} key={index}>{item}</option>
        ))}
      </Form.Select>
    </Row>
  );
};

export default GlassTimeCustomerListCustomer;